import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { DesktopButton } from 'shared/components/BannerAll';
import { LegacyDealerItem } from 'desktop/components/DealerItem/';

import s from './FirmList.css';

class FirmList extends React.Component {
  static propTypes = {
    firms: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    url: PropTypes.string.isRequired,
    searchForm: PropTypes.shape(),
  };
  static defaultProps = {
    searchForm: {},
  };
  render() {
    const { firms, url, searchForm: { results: { topFirms = [] } } } = this.props;
    const objKey = {};
    return (
      <div className={s.root}>
        {topFirms && topFirms.length > 0
          ? topFirms.map((item, idx) => {
              if (idx < 5) {
                objKey[item.id] = true;
                return (
                  <div key={`${item.id}-${item.slug}`}>
                    <div className={s.special}>
                      <FormattedMessage id="Топ" />
                    </div>
                    <LegacyDealerItem url={url} type={'firm'} dealer={item} />
                  </div>
                );
              }
              return '';
            })
          : ''}
        {firms && firms.length > 0
          ? firms.map((item, idx) => {
              if (objKey[item.id]) return '';
              return (
                <div key={`${item.id}-${item.slug}`}>
                  {idx === 6 ? <DesktopButton /> : ''}
                  <LegacyDealerItem url={url} type={'firm'} dealer={item} />
                </div>
              );
            })
          : ''}
        {!(firms && firms[0]) && !(topFirms && topFirms[0])
          ? <div className={s.default}>
              <FormattedMessage id="По Вашему запросу ничего не найдено" />
            </div>
          : ''}
      </div>
    );
  }
}

export default withStyles(s)(connect(({ searchForm }) => ({ searchForm }))(FirmList));



// WEBPACK FOOTER //
// ./src/desktop/routes/firms/components/FirmList/FirmList.js